import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface AgeOnboardingState {
  authenticated: boolean;
  status: "pending" | "soft_declared" | "soft_rejected" | "hard_verified" | "hard_rejected";
  has_date_of_birth: boolean;
  min_account_age: number;
  complete: boolean;
}

const DEFAULT_STATE: AgeOnboardingState = {
  authenticated: false,
  status: "pending",
  has_date_of_birth: false,
  min_account_age: 18,
  complete: false,
};

export const AGE_ONBOARDING_QUERY_KEY = "age-onboarding";

/**
 * État de la déclaration d'âge du compte connecté.
 *
 * Le calcul (âge civil vs seuil configurable) est fait côté serveur : le front
 * ne connaît que le verdict, jamais une valeur d'âge codée en dur.
 */
export const useAgeOnboarding = () => {
  const { user, loading: authLoading } = useAuth();

  const query = useQuery({
    queryKey: [AGE_ONBOARDING_QUERY_KEY, user?.id],
    enabled: !authLoading && !!user,
    staleTime: 60 * 1000,
    queryFn: async (): Promise<AgeOnboardingState> => {
      const { data, error } = await supabase.rpc("get_my_age_onboarding" as any);
      if (error) throw error;
      return { ...DEFAULT_STATE, ...((data ?? {}) as Partial<AgeOnboardingState>) };
    },
  });

  return {
    state: query.data ?? DEFAULT_STATE,
    isLoading: authLoading || (!!user && query.isLoading),
    refetch: query.refetch,
  };
};
